import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

const initProductSwiperFull = () => {
    const container: HTMLElement = document.querySelector<HTMLElement>('.product-swiper--full')

    if (container === null) {
        return
    }

    const swiper = new Swiper(container, {
        modules: [Navigation, Pagination],
        direction: 'horizontal',
        slidesPerGroup: 1,
        slidesPerView: 1.15,
        spaceBetween: 16,
        loop: true,
        pagination: {
            el: container.querySelector<HTMLElement>('.swiper-pagination'),
        },
        navigation: {
            nextEl: container.querySelector<HTMLElement>('.swiper-button-next'),
            prevEl: container.querySelector<HTMLElement>('.swiper-button-prev'),
        },
        breakpoints: {
            770: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
        },
    });
}

const initProductSwiperCompact = () => {
    const container: HTMLElement = document.querySelector<HTMLElement>('.product-swiper--compact')

    if (container === null) {
        return
    }

    const swiper = new Swiper(container, {
        modules: [Navigation, Pagination],
        direction: 'horizontal',
        slidesPerGroup: 1,
        slidesPerView: 1.15,
        spaceBetween: 16,
        pagination: {
            el: container.querySelector<HTMLElement>('.swiper-pagination'),
        },
        navigation: {
            nextEl: container.querySelector<HTMLElement>('.swiper-button-next'),
            prevEl: container.querySelector<HTMLElement>('.swiper-button-prev'),
        },
        breakpoints: {
            770: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
        },
    });
}

const initRelatedPostsSwiperCompact = () => {
    const container: HTMLElement = document.querySelector<HTMLElement>('.js-recent-posts')

    if (container === null) {
        return
    }

    const swiper = new Swiper(container, {
        modules: [Navigation, Pagination],
        direction: 'horizontal',
        slidesPerGroup: 1,
        slidesPerView: 1.15,
        spaceBetween: 16,
        breakpoints: {
            770: {
                slidesPerView: 2.15,
            },
            1126: {
                slidesPerView: 3,
            },
        },
    });
}

export default () => {
    initProductSwiperFull()
    initProductSwiperCompact()
    initRelatedPostsSwiperCompact()
}